<template>
    <div>
        <div v-for="columnIndex in columnIndices" :key="columnIndex" class="batchColumn">
            <sample-batch v-for="columnItem in getSamplesInColumn(columnIndex)" :batch="batch"
                          :key="columnItem.id"
                          :casesWithMissingSamples="casesWithMissingSamples"
                          :data="columnItem.data" :position="columnItem.pos"
                          :canMoveLeft="columnItem.canMoveLeft" :canMoveRight="columnItem.canMoveRight"
                          :current-case-id="currentCaseId" @change-current-case="handleChangeCurrentCase"></sample-batch>
        </div>
        <div class="cleaner"></div>
    </div>
</template>

<script>
    import _ from 'lodash'
    import SampleBatch from './SampleBatch'
    import {mapState, mapGetters} from 'vuex'

    const SamplesInColumnCount = 8

    export default {
        name: 'SampleBatchContainer',
        props: {
            batch: Object,
            batchSamplesByPosition: Object
        },
        components: {
            SampleBatch
        },
        data () {
          return {
              currentCaseId: null
          }
        },
        computed: {
            ...mapGetters('clients', {
                clientSpecialistsById: 'clientSpecialistsById',
                clientsById: 'clientsById'
            }),
            ...mapState('batches', {
                casesWithMissingSamples: 'casesWithMissingSamples'
            }),
            columnsCount() {
                if (this.batch.size === 0) {
                    return 0
                }

                if (this.batch.size <= SamplesInColumnCount) {
                    return 1
                }

                return Math.ceil(this.batch.size / SamplesInColumnCount)
            },
            columnIndices() {
                return _.range(0, this.columnsCount)
            }
        },
        methods: {
            /*getSampleDateByPosition(position) {
                _.get(this.)
            },*/
            getSamplesInColumn(columnIndex) {
                const offset = columnIndex * SamplesInColumnCount

                let columnData = []

                let limit = offset + SamplesInColumnCount + 1

                if (limit > this.batch.size) {
                    limit = this.batch.size + 1
                }

                const lastItem = _.get(this.batchSamplesByPosition, this.batch.size, null)

                for (let i = offset + 1; i < limit; i++) {
                    let data = _.get(this.batchSamplesByPosition, i.toString(), {})
                    data.clientTitle = _.get(this.clientsById, [data.clientId, 'title'], null)

                    let specialistComments = []

                    const clientSpecialistIds = _.get(data, 'clientSpecialistIds', [])

                    for (let clientSpecialistId of clientSpecialistIds) {

                        let comment = _.get(this.clientSpecialistsById, [clientSpecialistId, 'comment'], null)

                        if (comment === null) {
                            continue
                        }

                        specialistComments.push(comment)
                    }

                    data.specialistComment = null

                    if (specialistComments.length > 0) {
                        data.specialistComment = _.join(specialistComments, '; ')
                    }

                    let canMoveLeft = false
                    let canMoveRight = false

                    const sampleBatchId = _.get(data, ['id'], null)

                    // Если плашка в статусе preparing, то образцы можно двигать, если в любом другом статусе, то двигать нельзя
                    if (sampleBatchId && (this.batch.status === 'preparing')) {
                        // Если предыдущий элемент не установлен, то сдвиг влево возможнен
                        if (i !== 1) {
                            const prevItem = _.get(this.batchSamplesByPosition, (i - 1).toString(), null)

                            if (!prevItem) {
                                canMoveLeft = true
                            }
                        }

                        // Если последний элемент не установлен, то сдвиг вправо возможен
                        if (lastItem === null) {
                            canMoveRight = true
                        }

                        /*if (i + 1 < this.batch.size) {
                            const nextItem = _.get(this.batchSamplesByPosition, (i + 1).toString(), null)

                            if (!nextItem) {
                                canMoveRight = true
                            }
                        }*/
                    }

                    columnData.push({
                        pos: i,
                        data: data,
                        canMoveLeft: canMoveLeft,
                        canMoveRight: canMoveRight
                    })
                }

                return columnData
            },
            handleChangeCurrentCase: _.debounce(function (caseId) {
                this.currentCaseId = caseId
            }, 500),
        }
    }
</script>

<style scoped>
    .batchColumn {
        display: inline-block;
        float: left;
    }
</style>